<template>
	<div class="carousel in-block"  :class="transitionClass" v-if="isCarousel" :style="transitionStyle">
		<carousel
				:perPage=1
				:navigation-enabled="controls"
				:pagination-enabled="controls"
				:navigationClickTargetSize=15.4
				:pagination-size=18
				:pagination-padding="6"
				:autoplay="advance"
				:autoplay-timeout = "frameDuration*1000"
				:duration="frameDuration"
                @navigation-click="navigationHandler"
                @pagination-click="navigationHandler"
				:loop="true"
				:mouse-drag="false"
        :touch-drag="false"
				v-on:pageChange="pageChange"
				:aria-label="narration"
				:key="blockId"
				
		>
			<slide :class="[transitionClass, {initialSlide: currentSlide === 0 }]"><product-element v-bind="$props" /></slide>
			<slide v-for="(slide,i) in slideBlocks" :key="i" @slideclick="handleSlideClick" :class="transitionClass">
				<product-element :block-data="slide" v-bind="$props" />

			</slide>

		</carousel>
	</div>
</template>

<script>
import blockElementMixin from "@/mixins/blockElementMixin";
import ProductElement from "@/components/block/elements/ProductElement.vue";
import { Carousel, Slide } from 'vue-carousel';
import {mapActions} from "vuex";
import Lytics from "../../../classes/Lytics";

export default {
	name: "ProductCarousel",
	components: {ProductElement, Carousel, Slide},
	mixins:[blockElementMixin],
	props: {
    blockId: {
      type: String
    },
		isVisible: {
			type: Boolean,
			default: false
		},
		page: {
			type: Object,
			default: () => {
				return {};
			}
		}
  },
	data(){
		return {
			currentSlide: 0,
      narration:''
		}
	},
	mounted() {
		setTimeout(() => {
			const containers = document.getElementsByClassName('VueCarousel-dot-container');
			containers.forEach( container => {
				const dots = container.getElementsByClassName('VueCarousel-dot');
				dots.forEach((dot, index) => {
					dot['title'] = ``;
					dot['value'] = `Slide ${index+1}`;
					dot.setAttribute('aria-label', `Slide ${index+1}`);
				});
			});
		}, 1000)
    const blocks = this.slideBlocks
    this.narration = this.currentSlide === 0 ? this.blockData.products[0].contents :blocks[this.currentSlide-1].products[0].contents
	},
	computed:{
		slideBlocks(){
			return this.blockData?.carouselBlocks;
		},
		isCarousel() {
			return (this.blockData?.carouselBlocks?.length ?? 0) >= 1;
		},
		controls() {
			return this.blockData?.controls !== undefined ? this.blockData?.controls : true
		},
		advance() {
			return this.blockData?.advance  ?? false
		},
		frameDuration() {
			const duration = this.blockData?.fraDur ?? 1;
			return isNaN(duration) ? 1 : duration
		},
		transitionDuration() {
			return this.blockData?.transDur ? `${this.blockData.transDur}s` : `0.3s`;
		},
		transitionClass() {
			switch(this.blockData?.effect?.toLowerCase()) {
				case 'fading':
					   return 'fade-effect';
				case 'appear':
					   return 'appear-effect';
				case 'slide':
					   return 'slide-effect';
				default:
					  return 'slide-effect';
			}
		},
		transitionStyle() {
			return {'--trans-duration': `${this.transitionDuration}`}
		}
	},
	methods:{
		...mapActions('events', ['triggerEvent']),
		handleSlideClick (dataset) {
			console.log("Slide click info ",dataset.index, dataset.name)
		},
		navigationHandler(i){
           const direction = i > this.currentSlide ? 'right' : 'left';
           const blocks = this.slideBlocks
		   Lytics.TriggerCarouselClick({
				carousel_frame: i + 1,
				carousel_id: this.blockId,
				carousel_interaction: direction,
				carousel_url: blocks[i]?.images[0]?.image,
				total_click_include: true,
				page_number: this.page.page_num,
			})
            this.triggerEvent( {
              event: 'carouselInteraction',
              data: {
                 frame: i + 1,
                 direction: direction,
		        carouselId: this.blockId
            },
            })
		},
    pageChange(i)
    {
      if(i)
        this.currentSlide = i
      else
        this.currentSlide = 0

      const blocks = this.slideBlocks
      this.narration = this.currentSlide === 0 ? this.blockData.products[0]?.contents :blocks[this.currentSlide-1].products[0]?.contents
      const navBtns = document.getElementsByClassName('VueCarousel-navigation-button')
      navBtns.forEach((btn) => {
        btn.ariaLabel = this.narration
      });
     return this.currentSlide
    },
	},
	watch: {
		isVisible(val) {
			if (val) {
				Lytics.TriggerCarouselImpression({
					id: this.blockData.name,
					url: this.blockData?.carouselBlocks[this.currentSlide]?.images[0]?.image,
					frame: this.currentSlide + 1,
					frame_count: this.blockData?.carouselBlocks.length + 1,
					page_number: this.page.page_num,
				})
			}
		}
	}
}
</script>

<style lang="scss">
.ProductCarousel {
	display: initial !important;
	.carousel {
		.VueCarousel {
			position:inherit;

			.VueCarousel-inner {
			   	margin-left: -0.5px;
	        }

			.VueCarousel-navigation {
				position: relative;
				bottom:45px;
				margin:0 auto;

				.VueCarousel-navigation-button {
					cursor: pointer;
					background: none;
					height: 45px;
					width: 45px;
					background-size: contain;
					background-position: center;
					border-radius: 50%;
					font-size: 0;
					opacity: .7;
					transition: opacity 200ms, filter 100ms;
					z-index: 1100;
					margin:0 -80px;

					&:hover {
						opacity: 1;
					}
          &:focus{
            border: 5px solid var(--secondary-color)
          }
					&.VueCarousel-navigation-prev {
						background-image: url("/images/moveleft-arrow-desktop.png");
						//left: 36% !important;
					}
					&.VueCarousel-navigation-next {
						background-image: url("/images/moveright-arrow-desktop.png");
						//right: 36% !important;
					}
					&.VueCarousel-navigation--disabled {
						opacity: 0.3 !important;
					}
					&:focus:not(:focus-visible) {
						outline: none;
					}
				}
			}

			.VueCarousel-pagination {
				z-index: 1000;
				margin-top: -85px !important;

				.VueCarousel-dot-container {
					-webkit-backface-visibility: hidden;
					-ms-transform: translateZ(0); /* IE 9 */
					-webkit-transform: translateZ(0); /* Chrome, Safari, Opera */
					opacity: 0.9;
					background: none;
          pointer-events: none;

					&:hover {
						opacity: 1;

						.VueCarousel-dot--active{
							background: rgba(0, 0, 0) !important;
						}
					}
					.VueCarousel-dot {
						min-height: unset;
						min-width: unset;
						margin: 18px 6px !important;
						padding: 0 !important;
						border: 2px solid rgb(0, 0, 0);
						background: rgb(255, 255, 255) !important;

					}
					.VueCarousel-dot--active{
						background: rgba(0, 0, 0, 0.7) !important;
					}

				}
			}
		}
	}
  .carousel.slide-effect {
		.VueCarousel-inner {
			transition: transform var(--trans-duration) ease !important;
		}
	}
	.carousel.fade-effect {
		.VueCarousel-inner {
			transition: transform 0s !important;
			.VueCarousel-slide.fade-effect {
             opacity: 0;
             transition: opacity var(--trans-duration) ease;
            }
		   .VueCarousel-slide-active.fade-effect, 
		   .initialSlide.fade-effect {
            opacity: 1;
            }
		}

		
	}
	.carousel.appear-effect {
		.VueCarousel-inner {
			transition: transform 0s !important;
			.VueCarousel-slide.fade-effect {
             opacity: 0;
            }
		   .VueCarousel-slide-active.appear-effect, 
		   .initialSlide.appear-effect {
            opacity: 1;
            }
		}

		
	}
}

/*Mobile & Tablet*/
@media (min-width: 280px ) and (max-width: 1022px) {
	.carousel {
		.VueCarousel {
			.VueCarousel-navigation {
				.VueCarousel-navigation-button {
					height: 50px;
					width: 50px;
					font-size: 0;
				}
			}

			.VueCarousel-pagination {
				.VueCarousel-dot-container {
					.VueCarousel-dot {
						width: 22px !important;
						height: 22px !important;
					}
				}
			}
		}
	}
}
</style>